import { render, staticRenderFns } from "./ChartLegends.vue?vue&type=template&id=3d16d0cd&"
import script from "./ChartLegends.vue?vue&type=script&lang=js&"
export * from "./ChartLegends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports